module.exports = __webpack_public_path__ + "static/media/inceleme_videosu_ADIM2.6c11ed03.jpg";